import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { GamprotectTabState } from './GamprotectTab.state';
import { TextArea } from 'src/domains/common/components/textarea/textarea';
import { CustomDropdown } from 'src/components/RealityCheckForm/CustomDropdown';

interface ReasonFormPropsType {
    state: GamprotectTabState;
}

export const GamprotectReasonForm = observer('ReasonForm', ({ state }: ReasonFormPropsType) => {
    const possibleAction = state.possibleAction;

    if (possibleAction === null) {
        return null;
    }

    if (possibleAction.type === 'remove') {
        return (
            <>
                <p>Please provide the deletion reason</p>
                <TextArea
                    formInputState={state.reason}
                    errors={state.reason.errorsForView}
                    placeholder='Deletion Reason'
                    dataTest='gamprotect-deletion-reason'
                />
            </>
        );
    }

    return (
        <>
            <p>Please provide the entry reason</p>
            <CustomDropdown
                optionsList={state.entryReasons}
                selectedValue={(): string => state.reason.value}
                onChangeCallback={state.setReason}
                formInputState={state.reason}
                placeholder='Select entry reason'
                dataTest='gamprotect-entry-reason'
                labelHeader='Entry reason'
            />
        </>
    );
});
